<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">Clubbed to Death</p>
<p class="bkau">Ruth Dudley Edwards</p>
<p class="bkau1"><a href="http://www.ruthdudleyedwards.com" target="_blank">www.ruthdudleyedwards.com</a></p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="bkpub"><img alt="" src="ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppclubbeddeath002.vue?5f514eaf